<template>
  <div
    v-if="list_news?.length > 0"
    style="padding-bottom:0;"
    class="full-width"
  >
    <div class="golf-good-price mb-10">
      <p class="c-black-text c-bold-text title-h3  m-0">
        {{ title }}
      </p>
      <p @click="routePush" class="m-0 text-see-more cursor-pointer">
        {{ $t("viewAll") }}
      </p>
    </div>
    <el-row :gutter="20">
      <el-col
        v-for="(item, index) in list_news.slice(0, 6)"
        :key="index"
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12"
      >
        <card-news
          style="margin-bottom: 15px;"
          class="w-100"
          :object-data="item"
          :excerpt="item.excerpt"
          :title="item.title"
          :banner="item.banner"
          :author-name="item.author_name"
          :id="item.post_id"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import CardNews from "@/components/wapV2/cards/CardNewsMain.vue";
import ReviewFacility from "@/views/api/wapV2/review-facility";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "news-home",
  components: {
    CardNews
  },
  props: {
    listData: {
      type: Array,
      return: []
    },
    title: {
      type: String,
      default: ""
    }
  },
  created() {
    this.onGetList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["list_news"])
  },
  watch: {},

  data() {
    return {};
  },
  methods: {
    ...mapActions(["set_data_news"]),
    routePush() {
      return this.$router.push("/tin-tuc");
    },
    onGetList() {
      if (this.list_news.length > 0) return;
      ReviewFacility.get_data_post().then(res => {
        const { error_code, data = [] } = res;
        if (error_code === 0 && data.length > 0) {
          const mapData = data.map(i => {
            const obj = {
              ...i,
              id: i.course_id,
              title: i.post.title,
              excerpt: i.post.excerpt,
              banner: i.post.banner,
              author_name: i.post.author
            };
            return obj;
          });
          this.set_data_news(mapData);
        }
      });
    }
  }
};
</script>

<style>
.slick-slide {
  padding-right: 10px;
  padding-left: 10px;
}
</style>

<style scoped lang="scss">
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}
.title-h3 {
  font-size: 16px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 591px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .text-see-more {
    font-size: 10px;
  }
}
</style>
